import { HistoryTypes } from 'model/party/history/history';
import Debug from 'debug';
const debug = Debug('model:actions:die');

const notification = () => `too weak to continue`;

const attempt = () => {
  const result = {
    success: true,
    gain: { horse: false }
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { history, resources } = party;

  resources.delta({ ...result.gain }, context);

  // Reset party step, resources & location
  party.restore();

  // Track action
  history.add({ action: HistoryTypes.Death, result }, context);

  return {
    outcome: { isDead: true, step: party.step },
    notification: notification(result)
  };
};

const action = {
  title: '',
  enabled: () => true,
  execute: oldContext => {
    const result = attempt(oldContext);
    const { outcome, notification } = executeSideEffects(oldContext, result);

    debug('die');
    return { outcome, notification };
  }
};

export default action;
